<template>
  <div>
    <nav-breadcrumb :menu="[{label : '材料补充申请'}]"/>

    <el-row>
      <el-col>
        <panel label="基本信息">
          <el-form :model="dealerForm" :rules="dealerFormRules" ref="dealerForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="12">
                <el-form-item label="申请单号：" style="width: 60%">
                  <el-input value="待生成" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：" style="width: 60%">
                  <el-input value="待补充" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dealerForm.d__dealerCode!=''">
                <el-form-item label="申请环节：" style="width: 60%">
                  <el-select placeholder="请选择" v-model.trim="dealerForm.d__dealerTypeId" >
                    <el-option value="" >客户授信评估</el-option>
                    <el-option value="" >签订贷款合同</el-option>
                    <el-option value="" >贷款放款审批</el-option>
                    <el-option value="" >贷款还款期间</el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="关联单号：" prop="d__dealerName" style="width: 60%">
                  <el-input v-model="dealerForm.d__dealerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="申请原因：" prop="d__personInCharge" style="width: 60%">
                  <el-input v-model="dealerForm.d__personInCharge"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="申请人：" prop="d__contactNo" style="width: 60%">
                 111
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </panel>
        <panel label="补充材料">

        </panel>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="onSubmit('dealerForm')">确认提交</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Panel from "../../components/Panel";
    export default {
        name: "InfoSupplyAdd",
      components: {Panel},
      data(){
        return {
          dealerId: this.$route.query['dealerId']||'',
          dealerForm:{
            d__disabled: 'N'
          },
          deviceTypeOptions : [],
          interestTypeOptions:[
            {
              label:'年利率',
              value:'Yearly'
            },
            {
              label:'月利率',
              value:'Monthly'
            },
            {
              label:'日利率',
              value:'Daily'
            }
          ],
          disabledOptions:[
            {
              label:'启用',
              value:'N'
            },
            {
              label:'禁用',
              value:'Y'
            },
          ],
          dealerFormRules: {},
        }
      },
      mounted() {
        if(this.dealerId){
          this.getData()
        }
        this.getDealerType()
      },
      methods:{
        getData:function(){
          xhr.getDealer({
              'd.dealerId': this.dealerId
            },
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.dealerForm = res.data.data
                }
              }catch (e) {

              }
            })
        },
        getDealerType: function () {
          xhr.getDealerType(
            Object.assign({}, {}, {}),
            res=> {
              try {
                this.deviceTypeOptions = res.data.data.map(item=>{
                  return {
                    label: item.dt__name,
                    value:item.dt__dealerTypeId,
                  }
                })
              }catch(e){

              }
            })

        },
        onSubmit: function (formName) {
          let dealerForm = this.dealerForm
          this.$refs[formName].validate(valid=> {
            if (valid) {
              dealerForm.d__checked = true
              xhr.updateDealer(dealerForm, res=> {
                try {
                  if (res.data.status == 'success') {
                    this.$router.push({
                      name: 'DealerListView'
                    })
                  }
                } catch (e) {
                }
              })
            }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/InfoSupplyAdd.vue